import { DollarOutlined } from '@ant-design/icons'
import { Col, Input, Modal, Row, Table, Button } from 'antd'
import React, { useEffect, useState } from 'react'
import { openNotification } from '../../../utils/Notifactions'
import apiParticipantes from '../../../api/Participantes/api-participantes'
import { ObjNotificaciones } from '../../../config/notificaciones'

type ModalListadoProps = {
    openModal: boolean,
    setOpenModal: Function,
    datos: any,
    setPostulaciones: any,
    setTodasLasPostulaciones: any,
    buscarFiltros: Function
}
export const ModalListado = ({ openModal, setOpenModal, datos, setPostulaciones, setTodasLasPostulaciones, buscarFiltros }: ModalListadoProps) => {

    const [dataProyectoJurado, setDataProyectoJurado] = useState<any>([])
    const [sumaPagar, setSumaPagar] = useState<any>(0)


    useEffect(() => {
        if (openModal && datos) {
            // Convertir datos a array si es necesario para la tabla
            const datosArray = Array.isArray(datos) ? datos : [datos];
            // Inicializar el precio si no existe
            const datosConPrecio = datosArray.map((item: any) => ({
                ...item,
                precio: item.precio ?? item.postulacion?.precio ?? null
            }));
            setDataProyectoJurado(datosConPrecio);
            // Calcular suma inicial
            const sumaInicial = datosConPrecio.reduce((sum: number, item: any) => {
                const precio = item.precio ?? item.postulacion?.precio;
                return sum + (precio ? Number(precio) : 0);
            }, 0);
            setSumaPagar(sumaInicial);
        } else {
            setDataProyectoJurado([]);
            setSumaPagar(0);
        }
    }, [openModal, datos])

    const onChangePagar = (datosItem: any, precio: string) => {
        // Limpiar caracteres no numéricos
        const precioLimpio = precio.replace(/\D/g, '');
        const precioNumero = precioLimpio === '' ? null : Number(precioLimpio);

        // Actualizar el precio en el array
        const proyectosActualizados = dataProyectoJurado.map((x: any) => {
            if (datosItem.id_postulacion === x.id_postulacion) {
                return {
                    ...x,
                    precio: precioNumero,
                    postulacion: {
                        ...x.postulacion,
                        precio: precioNumero
                    }
                }
            }
            return x;
        });

        setDataProyectoJurado(proyectosActualizados);

        // Calcular la suma total
        const sumaTotal = proyectosActualizados.reduce((sum: number, item: any) => {
            const precioItem = item.precio ?? item.postulacion?.precio;
            return sum + (precioItem ? Number(precioItem) : 0);
        }, 0);

        setSumaPagar(sumaTotal);
    }



    const onClose = async () => {
        setOpenModal(!openModal);
    }


    const columns: any = [
        {
            title: "No.",
            width: 10,
            // dataIndex: "",
            key: "index",
            render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
        },
        {
            title: "Nombre proyecto",
            width: 50,
            dataIndex: "nombre_propuesta",
            key: "nombre_propuesta",
        },
        {
            title: "Código",
            width: 50,
            dataIndex: "radicado",
            key: "radicado",
        },
        {
          title: "Línea convocatoria",
          width: 100,
          render: (datos) => {
              return (
                  <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line",  fontWeight: "bold"}}>
                    {datos.linea_convocatoria}
                  </span>
              );
          }
        },
        {
            title: "Cateogoría",
            width: 100,
            dataIndex: "categoria_linea_convocatoria",
            key: "categocategoria_linea_convocatoriaria",
        },
        {
            title: "Valor a pagar",
            width: 140,
            key: 'valor_pagar',
            render: (datos: any, record: any, idx: number) => {
                // Usar el precio actualizado o el precio de postulacion como fallback
                const valorPrecio = datos.precio ?? datos.postulacion?.precio ?? '';
                return (
                    <Input
                        type="text"
                        id={`pagar_${idx}`}
                        value={valorPrecio === null || valorPrecio === undefined ? '' : valorPrecio.toString()}
                        style={{ textAlign: "right" }}
                        onChange={(e) => {
                            onChangePagar(datos, e.target.value)
                        }}
                        prefix={<DollarOutlined />}
                        placeholder="0"
                    />
                );
            }
        }
    ]

    const guardarTodo = async () => {

        let existeUnoSinPrecio = dataProyectoJurado.find((x: any) => x.precio == null);
        if (existeUnoSinPrecio) {
            return openNotification({
                titulo: "Error",
                descripcion: "Faltan proyectos por poner el precio",
                placement: "bottomRight",
            });
        }



        // Ejecutar todas las actualizaciones en paralelo
        await Promise.all(
            dataProyectoJurado.map(async (x: any) => {
                try {
                    await apiParticipantes.actualizarPagoProyecto(x.id_postulacion, x.precio)
                    await apiParticipantes.cambiarEstadoPostulacion({ id_postulacion: x.id_postulacion , estado: 'Beneficiario' });
                } catch (error) {
                    console.log(error);
                }
            })
        );

        ObjNotificaciones.MSG_SUCCESS('success', '¡Registro éxitoso, se han actualizado los pagos!');
        
        // Cerrar el modal
        setOpenModal(!openModal);
        
        // Ejecutar búsqueda nuevamente para actualizar la lista
        if (buscarFiltros) {
            await buscarFiltros();
        }
    }

    const currency = function (number: number) {
        return new Intl.NumberFormat('en-ES', { style: 'currency', currency: 'COP', minimumFractionDigits: 2 }).format(number);
    };



    return (
        <Modal
            className='ant-modal-close-x2'
            title={
                <div style={{ display: 'flex' }}>
                    <div className='pe-3 d-flex flex-column flex-md-row font-size-14px font-color-000000CC font-family-Montserrat-SemiBold'>
                        Ingreso de pago
                    </div>
                </div>
            }
            width={1700}
            visible={openModal}
            onCancel={onClose}
            maskStyle={{
                backgroundColor: "rgba(6, 100, 144 ,0.8)",
            }}
            footer={
                    <div className="container-fluid">
                        <Button className="button-gray-ghost" onClick={onClose}>
                            Cerrar
                        </Button>
                        <Button className="button-azul-radius" onClick={guardarTodo}>
                            Guardar cambios
                        </Button>
                    </div>
            }
        >
            <Table
                style={{ borderTop: "1px solid #C4C4C4" }}
                // locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                // pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: cantidadPaginas }}
                dataSource={Array.isArray(dataProyectoJurado) ? dataProyectoJurado : []}
                columns={columns}
                size="small"
                bordered={false}
                pagination={false}
            />

            <Row justify='end'>
                <Col>
                    <div className='font-size-12px font-color-000000CC font-family-Montserrat-SemiBold' style={{ marginTop: '13px' }}>
                        Total a pagar: $ {currency(sumaPagar)}
                    </div>
                </Col>
            </Row>
        </Modal>
    )
}
